import Container from 'react-bootstrap/Container';
import AppButton from '../atoms/AppButton';
import { IconArrowRight, IconWhatsapp } from '../atoms/Icon';
import { chamadaFinal, contato, cta } from '../content/site';
import { trackEvent } from '../utils/analytics';

/** A última chamada. Repete a ação do herói de propósito: quem rolou a página
 *  inteira não deveria ter que voltar ao topo para encontrar o botão. */
function FinalCta() {
  return (
    <section className="section section--ghost">
      <Container className="shell">
        <div className="section-head section-head--center mb-4">
          <h2 className="section-title">{chamadaFinal.titulo}</h2>
          <p className="section-lead">{chamadaFinal.texto}</p>
        </div>

        <div className="d-flex flex-wrap justify-content-center gap-3">
          <AppButton
            href={cta.principal.href}
            variant="whatsapp"
            size="lg"
            onClick={() => trackEvent('click_whatsapp', { posicao: 'chamada_final' })}
          >
            <IconWhatsapp size={19} />
            {cta.principal.label}
          </AppButton>
          <AppButton
            href={`mailto:${contato.email}`}
            variant="ghost"
            size="lg"
            onClick={() => trackEvent('click_email', { posicao: 'chamada_final' })}
          >
            Mandar um e-mail
            <IconArrowRight size={17} />
          </AppButton>
        </div>
      </Container>
    </section>
  );
}

export default FinalCta;
